/* src/components/project-quickscan-result/project-quickscan-result.component.scss */
:host {
  display: block;
}
:host .flex-wrapper {
  display: flex;
  flex-direction: column;
}
:host .flex-end {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
:host .block-chart-signal {
  --chart-signal-matrix-height: 238px;
  --chart-signal-matrix-max-height: 238px;
}
:host.align-left .main-wrapper {
  margin: 0;
}
/*# sourceMappingURL=project-quickscan-result.component-NGO4VWTL.css.map */
